import ActionTypes from '../constants/ActionTypes';
import { State } from '../reducers';

export function getPageById(state: State, id: number) {
  return state.pages.list[id];
}

export function getPageStatusById(state: State, id: number) {
  return state.pages.status[id] || ActionTypes.FETCH_PAGE_NOT_FOUND;
}

export function isPageLoaded(state: State, id: number) {
  return (
    state.pages.status[id] === ActionTypes.FETCH_PAGE_REQUEST ||
    state.pages.status[id] === ActionTypes.FETCH_PAGE_SUCCESS
  );
}
